import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";
import {
  AMBER_INK,
  AMBER_SOFT_BG,
  GREEN_INK,
  GREEN_SOFT_BG,
  VIOLET_SOFT_BG,
} from "apps/project-iq/utils/diagnosticUtils";

const SECTION_ICON_SIZE = "22px";
const ANALYTICS_ICON_SIZE = "40px";
const CARD_BUTTON_PADDING = "18px";
const CARD_BUTTON_PADDING_RIGHT = "52px";

export const useAnalyticsCardStyles = makeStyles({
  analyticsCard: {
    position: "relative",
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
    overflow: "hidden",
    transition: `box-shadow ${designTokens.transition.fast}, transform ${designTokens.transition.fast}`,
    ":hover": {
      boxShadow: projectIqTokens.shadow,
      transform: "translateY(-1px)",
    },
    ":active": {
      transform: "translateY(0)",
      boxShadow: projectIqTokens.shadowSm,
    },
  },

  analyticsCardButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
    padding: CARD_BUTTON_PADDING,
    paddingRight: CARD_BUTTON_PADDING_RIGHT,
    width: "100%",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    textAlign: "left",
    fontFamily: projectIqTokens.fontFamily,
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.violet}`,
      outlineOffset: "2px",
    },
  },

  analyticsIcon: {
    width: ANALYTICS_ICON_SIZE,
    height: ANALYTICS_ICON_SIZE,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "11px",
    fontSize: SECTION_ICON_SIZE,
    backgroundColor: VIOLET_SOFT_BG,
    color: projectIqTokens.violet,
  },

  analyticsCardBody: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },

  analyticsCardNameRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    overflow: "hidden",
  },

  analyticsCardName: {
    fontWeight: 800,
    fontSize: "15.5px",
    color: projectIqTokens.ink,
    letterSpacing: "-0.01em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },

  analyticsCardStatusPill: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: "10.5px",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    borderRadius: "5px",
    padding: "3px 7px",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },

  analyticsCardStatusInProgress: {
    backgroundColor: AMBER_SOFT_BG,
    color: AMBER_INK,
  },

  analyticsCardStatusCompleted: {
    backgroundColor: GREEN_SOFT_BG,
    color: GREEN_INK,
  },

  analyticsCardStatusDraft: {
    backgroundColor: projectIqTokens.bg2,
    color: projectIqTokens.muted,
  },

  analyticsCardStatusError: {
    backgroundColor: projectIqTokens.rustBg,
    color: projectIqTokens.rust,
  },

  analyticsCardDescription: {
    fontSize: "12.5px",
    color: projectIqTokens.muted,
    fontStyle: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    margin: 0,
  },

  analyticsCardDescriptionEmpty: {
    fontSize: "12.5px",
    color: projectIqTokens.faint,
    fontStyle: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    margin: 0,
  },

  analyticsCardMeta: {
    fontSize: "12px",
    color: projectIqTokens.muted,
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },

  analyticsCardMetaAttachments: {
    color: projectIqTokens.violet,
    fontWeight: 700,
  },

  actionArea: {
    position: "absolute",
    top: "50%",
    right: designTokens.spacing[3],
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    opacity: 0,
    transition: `opacity ${designTokens.transition.fast}`,
    ":focus-within": {
      opacity: 1,
    },
  },

  actionAreaVisible: {
    opacity: 1,
  },
});
